/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateInstrumentLinksFromFranklinRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateInstrumentLinksFromFranklin.pb'
import {UpdateInstrumentLinksFromFranklinResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateInstrumentLinksFromFranklin.pb'


export const updateInstrumentLinksFromFranklin = (request: UpdateInstrumentLinksFromFranklinRequest, options?: CashRequestOptions) => post<UpdateInstrumentLinksFromFranklinRequest, UpdateInstrumentLinksFromFranklinResponse>("/2.0/cash/update-instrument-links-from-franklin", request, {...options, rejectOnError: true })